import Typography from '@mui/material/Typography';
import useOnboardingSx from '../../hooks/useOnboardingSx';

export default function RequiredLabel({ children }) {
  const sx = useOnboardingSx();

  return (
    <Typography component="span">
      {children}{' '}
      <Typography component="span" sx={sx.requiredMark}>
        *
      </Typography>
    </Typography>
  );
}
